<div class="container">
  <div class="row">
    <ng-container *ngIf="isSearchLoading$ | async as isSearchLoading">
      <app-loading class="search-result-container" text="{{ searchinDomainMessage | translate }}"></app-loading>
    </ng-container>

    <div class="domain-search-result-container search-result-container p-4"
         *ngIf="errorSearchEmptyVisible$ | async as errorSearchVisible">
      <span class="searchResult-error-description">{{ domainSearchErrorMessage | translate}}</span>
    </div>

    <div class="domain-search-result-container search-result-container p-4"
         *ngIf="errorSearchLengthVisible$ | async as errorSearchVisible">
      <span class="searchResult-error-description fs-l">{{ domainSearchLengthErrorMessage | translate}}</span>
    </div>

    <div class="domain-search-result-container search-result-container p-4"
         *ngIf="errorSearchMxVisible$ | async as errorSearchVisible">
      <span class="searchResult-error-description fs-l">{{ domainSearchMxErrorMessage | translate}}</span>
    </div>

    <!--Principal search result-->
    <ng-container *ngIf="searchResultVisible$ | async as searchErrorVisible">
      <div class="col-12 search-result-container">

        <!-- Display search result -->
        <ng-container *ngIf="(simpleSearch$ | async) === true">
          <app-search-domain-single-result [domain]="domainFinded$ | async" [showPricesInSearch]="showPricesInSearch" [onlyTldMx]="onlyTldMx" [buttonAddtoCartText]="buttonAddtoCartText"></app-search-domain-single-result>
        </ng-container>

      </div>
    </ng-container>
  </div>
</div>
